import ScrollTrigger from 'gsap/ScrollTrigger'
import { CalendarProvider, ContactProvider, Header } from './src/components'
import React from 'react'

export function shouldUpdateScroll() {
  window.scrollTo(0, 0)
  ScrollTrigger.refresh()
  return false
}

export function wrapPageElement({ element, props }) {

  if(props.location.pathname.includes('atd')){
    return element
  }

  return (
    <CalendarProvider>
      <ContactProvider>
        <Header>
          {element}
        </Header>
      </ContactProvider>
    </CalendarProvider>
  )
}